module.exports = __webpack_public_path__ + "static/img/rfid_mfrc_522-1.c380533.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/rfid_mfrc_522-1.svg
// module id = 6Vbv
// module chunks = 0